import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from "react-i18next";
import { useProfileModal } from "@/contexts/ProfileModalContext";
import { ProfileFormContent } from "./ProfileFormContent";
import { SecurityFormContent } from "./SecurityFormContent";
import { PrivacyCenter } from "@/components/privacy/PrivacyCenter";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useCurrentUser } from "@/hooks/useProfileQueries";

export function ProfileModal() {
  const { t } = useTranslation('common');
  const { isOpen, closeProfileModal } = useProfileModal();
  const { data: user } = useCurrentUser();

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && closeProfileModal()}>
      <SheetContent side="right" className="w-full sm:max-w-xl p-0">
        <SheetHeader className="p-6 pb-2">
          <SheetTitle>{t('profile.title', 'My Profile')}</SheetTitle>
          <SheetDescription>
            {t('profile.update', 'Update your personal information')}
          </SheetDescription>
        </SheetHeader>
        
        <Tabs defaultValue="profile" className="flex flex-col h-[calc(100%-80px)]">
          <div className="px-6">
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="profile">{t('profile.tabs.profile', 'Profile')}</TabsTrigger>
              <TabsTrigger value="security">{t('profile.tabs.security', 'Security')}</TabsTrigger>
              <TabsTrigger value="privacy">{t('profile.tabs.privacy', 'Privacy')}</TabsTrigger>
            </TabsList>
          </div>

          <ScrollArea className="flex-1 px-6 pb-6">
            <TabsContent value="profile" className="mt-4">
              <ProfileFormContent onSuccess={closeProfileModal} />
            </TabsContent>

            <TabsContent value="security" className="mt-4">
              <SecurityFormContent />
            </TabsContent>

            <TabsContent value="privacy" className="mt-4">
              {user?.id && <PrivacyCenter userId={user.id} />}
            </TabsContent>
          </ScrollArea>
        </Tabs>
      </SheetContent>
    </Sheet>
  );
}
